import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { md3 } from 'vuetify/blueprints'

import { createVuetify } from 'vuetify'

const haskoningLight = {
	dark: false,
	colors: {
		background: '#FFFFFF',
		surface: '#FFFFFF',
		primary: '#009EAB',
		secondary: '#009EAB',
		highlight: '#CCECEE',
		speckleColor: '#047EFB'
	}
}

export default createVuetify({
	blueprint: md3,
	theme: {
		defaultTheme: 'haskoningLight',
		themes: {
			haskoningLight: haskoningLight
		}
	},
	defaults: {
		VTextField: {
			color: 'primary',
			variant: 'filled'
		},
		VNumberInput: {
			color: 'primary',
			variant: 'filled'
		},
		VSelect: {
			color: 'primary',
			variant: 'filled'
		},
		VCombobox: {
			color: 'primary',
			variant: 'filled'
		},
		VTextarea: {
			color: 'primary',
			variant: 'filled'
		},
		VAutocomplete: {
			color: 'primary',
			variant: 'filled'
		},
		VProgressLinear: {
			color: 'primary'
		},
		VFileInput: {
			color: 'primary',
			variant: 'filled'
		}
	}
})
